import 'appstart';
//import 'SCSSEntries/questionPage.scss';
import 'left_menu';
//import 'jquery-match-height';

//import 'jquery-ui';
//import 'jquery-ui/ui/widgets/datepicker';
import 'Vendors/datepicker/datepicker-with-locales';
import 'parsley';

import { showSection, hideSection } from 'Utils/section';
import { /*datepickerHelpText,*/ addDays } from 'Utils/datepicker-helper';
import { InitScript_InquiryValidators } from 'SrcJS/validators/inquiry-validators';


global.showSection = showSection;
global.hideSection = hideSection;
global.addDays = addDays;
global.moment = moment;

$.datepicker.regional[AppData.CurrentLocale.toLowerCase()];

//global.InitScript_InquiryValidators = InitScript_InquiryValidators;
//document.addEventListener("DOMContentLoaded", function () {
//AppLoader.ready(function () {
    InitScript_InquiryValidators();
    //$('#questionsform').parsley().refresh();

    let $questionsform = $('#questionsform');
    if($questionsform.length > 0) {
        $questionsform.parsley().on('form:validate', function (formInstance) {
            //var ok = formInstance.isValid({ group: 'Question', force: true }) && formInstance.isValid({ group: 'ContactInfo', force: true });
            let ok = formInstance.isValid({ group: 'Question', force: true });
            ok = ok && formInstance.isValid({ group: 'ContactInfo', force: true });
            if (!ok)
                formInstance.validationResult = false;
        });
        $questionsform.parsley().on('parsley:form:validated', function (formInstance) {
            var holder = $('.parsley-errors-list.filled.recaptcha');

            if (formInstance.isValid({ force: true })) {
                var text = $("textarea[name='g-recaptcha-response']").val();
                if (text != "")
                    return;
                else {
                    showSection(holder);
                    formInstance.submitEvent.preventDefault();
                }
            } else {
                formInstance.submitEvent.preventDefault();
            }
        });
    }

//});
//});


//AppLoader.setReady();